if (typeof SidebarDrawer !== 'function') {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
    			this.siteOverlay = document.getElementById('site-overlay');
    			this.querySelector('.site-close-handle').addEventListener('click', ()=>{
              this.hide();
			});
		}

		show(){
			this.style.display = 'block';
			setTimeout(()=>{
				this.classList.add('active');
				// window.inertElems.forEach(elm=>{
				// 	elm.setAttribute('inert', '');
				// });
			}, 10);
			// this.siteOverlay.classList.add('active');
			document.body.classList.add('sidebar-move');
			document.querySelector('html').classList.add('kill-overflow');
			this.style.height = `${window.innerHeight}px`;
			if ( this.id == "site-cart" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}
		}

		hide(){
			this.classList.remove('active');
			// this.siteOverlay.classList.remove('active');
			document.body.classList.remove('sidebar-move');
			document.querySelector('html').classList.remove('kill-overflow');
			document.querySelector('body').classList.remove('drawer-menu-opened');
			// window.inertElems.forEach(elm=>{
			// 	elm.removeAttribute('inert');
			// })
			setTimeout(()=>{
				this.style.display = 'none';
			}, 250);
		}

	}


  if (typeof customElements.get('sidebar-drawer') == 'undefined') {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

document.addEventListener('DOMContentLoaded', function() {
  const mobileNav = document.getElementById('site-nav--mobile');
  const menuHandles = document.querySelectorAll('.site-burger-handle');
  const closeHandles = document.querySelectorAll('.site-close-handle');

  menuHandles.forEach(handle => {
    handle.addEventListener('click', function() {
      mobileNav.classList.toggle('active');
    });
  });
  closeHandles.forEach(handle => {
    handle.addEventListener('click', function() {
      mobileNav.classList.toggle('active');
    });
  });

  document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
    document.querySelectorAll('.mega-link').forEach(item => {
      if(item.hasAttribute('aria-controls')) {
        // UPDATED CODE BELOW - only modifying this section
        const childLink = item.querySelector('.child-link');
        const babyMenu = item.querySelector('.babymenu');
        
        childLink.addEventListener('click', e => {
          const isExpanded = item.getAttribute('aria-expanded') === 'true';
          
          if(!isExpanded) {
            // First click: prevent navigation and expand the submenu
            e.preventDefault();
            item.setAttribute('aria-expanded', 'true');
            babyMenu.style.display = 'block';
          } 
          // Second click: do nothing, let the default navigation happen
        });

        // Handle clicks on the parent item (not including child link)
        item.addEventListener('click', e => {
          // Only handle this if the click is not on the child link
          if(e.target !== childLink && !childLink.contains(e.target)) {
            const isExpanded = item.getAttribute('aria-expanded') === 'true';
            if(!isExpanded) {
              // Expand the submenu
              item.setAttribute('aria-expanded', 'true');
              babyMenu.style.display = 'block';
            } else {
              // Collapse the submenu
              item.setAttribute('aria-expanded', 'false');
              babyMenu.style.display = 'none';
            }
          }
        });
      }
    });
  });
});
